
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENTID,
        authority: process.env.REACT_APP_AUTHORITY,
        redirectUri: process.env.REACT_APP_REDIRECT_URL,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
    }
};

export const loginRequest = {
    scopes: [process.env.REACT_APP_LOGIN_REQUEST_SCOPE]
};

export const tokenRequest = {
    scopes: [process.env.REACT_APP_TOKEN_REQUEST_SCOPE]
};